import snakeCase from 'lodash.snakecase';

export const snakeCaseKeys = values => {
  return Object.entries(values).reduce((acc, curr) => {
    const key = snakeCase(curr[0]);
    return { ...acc, [key]: curr[1] };
  }, {});
};

export const camelCaseKey = value => {
  return value
    .split('_')
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join('');
};

export const imgOnError = ({ target }) => {
  // stash
  if (!target.dataset.src) target.dataset.src = target.src;
  // immediately use 1px placeholder
  target.src =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  if (!target.dataset.retried)
    setTimeout(() => {
      // retry image load in 2s
      target.src = `${target.dataset.src}?${Date.now()}`;
      target.dataset.retried = true;
    }, 2000);
};
